import styled from '@emotion/styled';

export const Gradient = styled.div`
    width: 100%;
    min-height: 100vh;
    background-image: linear-gradient(to top right, #2063e4, #ffa3ff, #ffd34e);
`;